module.exports = __webpack_public_path__ + "static/media/visio2019.df1bec46.png";